export default "__VITE_ASSET__Bkd2loHw__"